import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BCMCLPUser, TeamCodes, UserResponse } from '../../../models/clpuser.model';
import { CMClub, CMSite } from '../../../models/cm-club-service.model';
import { CMDashBoardResponse } from '../../../models/cm-dashboard.modal';
import { RoleFeaturePermissions } from '../../../models/role-container.model';
import { CMClubService } from '../../../services/cm-club.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';

@Component({
    selector: 'app-mem-dashboard',
    templateUrl: './mem-dashboard.component.html',
    styleUrls: ['./mem-dashboard.component.css']
})
/** mem-dashboard component*/
export class MemDashboardComponent {
    private encryptedUser: string = '';
    userResponse: UserResponse;
    user: BCMCLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;
    selectedCtDtFilter: number = 1;
    customDateStr: string = '';
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCtDtFilterName: string;
    selectedCustomdtStart: string = '';
    selectedCustomdtEnd: string = '';
    customFilter: boolean = false;
    cmDashBoardResponse: CMDashBoardResponse;
    teamSub: Subscription
    routeNameSUb: Subscription
    updateTeamSub: Subscription
    curSiteSub: Subscription
    curTeam: TeamCodes = <TeamCodes>{};
    sites: CMSite[];
    curSite: CMSite = <CMSite>{};
    clpCompanyId: number = 0;
    clubConfig: CMClub;
    
    
   
    /** mem-dashboard ctor */
    constructor(private localService: LocalService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _globalService: GlobalService,
        //private titleService: Title,
        private _utilityService: UtilityService,
        private datePipe: DatePipe,
        private clubService: CMClubService,
        private _teamOfficeService: TeamOfficeService    ) {
        //this.localService.setShowMenu(true);
        //this.localService.setIsMembership(true);
        //this.localService.setRouteName("m-dashboard");
    }

    async ngOnInit() {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-dashboard");
        this.localService.updateTeamDD(true)

        const queryParams = this._route.snapshot.queryParams;

        let currUserToken = localStorage.getItem("token") ? localStorage.getItem("token") : null;
        if (currUserToken == null) {
            this.encryptedUser = queryParams['r'];
        } else {
            this.encryptedUser = currUserToken;
        }

        if (this.encryptedUser) {

            await this.authenticateR();

            if (this.user) {
                localStorage.setItem("token", this.encryptedUser)
                this._router.navigate(['/mem-dashboard']);
                //this.loadData();
            }
            else {
                this.encryptedUser = queryParams['r'];
                await this.authenticateR();
                if (this.user) {
                    localStorage.setItem("token", this.encryptedUser);
                    this._router.navigate(['/mem-dashboard']);
                    //this.loadData();
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            }

        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    console.log(this.user)
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                    this.clpCompanyId = this.user.cLPCompanyID;

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

}
